export default "__VITE_ASSET__db5752bc__"